import React, { forwardRef } from "react";
import { Link, LinkProps } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { getLocalizedPath } from "@/i18n";

export interface LocalizedLinkProps extends Omit<LinkProps, "to"> {
  to: string;
}

export const LocalizedLink = forwardRef<HTMLAnchorElement, LocalizedLinkProps>(
  ({ to, children, ...props }, ref) => {
    const { i18n } = useTranslation();
    const localizedTo = getLocalizedPath(to, i18n.language);

    return (
      <Link ref={ref} to={localizedTo} {...props}>
        {children}
      </Link>
    );
  },
);

LocalizedLink.displayName = "LocalizedLink";

export default LocalizedLink;
